import type { ApiClient, Appointment } from "@shyne/shared/api";
import type { uuid } from "@/interfaces";

type MarkDoneApi = Pick<ApiClient["appointments"], "markDone">;

export function createMarkDone(api: MarkDoneApi) {
  return function markDone(id: uuid, actingOrganization: uuid | null): Promise<Appointment> {
    return api.markDone(id, actingOrganization ? { actingOrganization } : {});
  };
}
